module.exports = __webpack_public_path__ + "static/img/tips.97d08fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/tips.png
// module id = 9/Xi
// module chunks = 1